// Единый источник крошек market-страницы. Видимые крошки (Breadcrumbs.jsx) и
// разметка BreadcrumbList (Market.jsx) обязаны совпадать: разметка, не
// соответствующая видимому контенту, — нарушение правил structured data.
// Поэтому оба берут цепочку отсюда.

export const SERVICES_CRUMB_TITLE = "Услуги";

export function getMarketCrumbs(mode, pathname) {
  const title = mode?.intro?.title;
  if (!title) return [];

  return [
    { title: SERVICES_CRUMB_TITLE, path: "/" },
    { title, path: pathname || mode.path },
  ];
}
